import { api } from "./client";

export interface ThreadSummary {
  id: number;
  title: string;
  pinned: boolean;
  archived: boolean;
  message_count: number;
  last_message_preview: string;
  last_message_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface ChatAttachment {
  id: number;
  path: string;
  mime_type: string;
  original_name: string | null;
  position: number;
}

export interface ThreadMessage {
  id: number;
  role: "user" | "assistant" | "system" | string;
  content: string;
  created_at: string;
  attachments: ChatAttachment[];
}

export interface ThreadDetail {
  id: number;
  title: string;
  pinned: boolean;
  archived: boolean;
  created_at: string;
  updated_at: string;
  messages: ThreadMessage[];
}

export interface SendResponse {
  thread: { id: number; title: string; pinned: boolean; archived: boolean };
  user_message: ThreadMessage;
  assistant_message: ThreadMessage;
  knowledge_created: Array<{ id: number; title: string; category: string }>;
  model_used: string | null;
}

export async function listThreads(archived = false): Promise<ThreadSummary[]> {
  const { data } = await api.get<{ threads: ThreadSummary[] }>(
    `/coach/chat/threads?archived=${archived}`,
  );
  return data.threads;
}

export async function getThread(id: number): Promise<ThreadDetail> {
  const { data } = await api.get<ThreadDetail>(`/coach/chat/threads/${id}`);
  return data;
}

export async function updateThread(
  id: number,
  patch: { title?: string; pinned?: boolean; archived?: boolean },
): Promise<ThreadDetail> {
  const { data } = await api.patch<ThreadDetail>(
    `/coach/chat/threads/${id}`,
    patch,
  );
  return data;
}

export async function deleteThread(id: number): Promise<void> {
  await api.delete(`/coach/chat/threads/${id}`);
}

export async function sendChatMessage(
  text: string,
  opts: { threadId?: number | null; files?: File[] } = {},
): Promise<SendResponse> {
  const fd = new FormData();
  fd.append("text", text);
  if (opts.threadId != null) fd.append("thread_id", String(opts.threadId));
  for (const f of opts.files || []) fd.append("files", f, f.name);
  const { data } = await api.post<SendResponse>("/coach/chat/send", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
